<div #actionPreviewContainer class="actions-previews-container">
  @for (campaign of store().campaigns(); track index; let index = $index) {
    <div class="campaigns-container">
      <app-action-card-preview [campaignDetails]="campaign"
                               [campaignUserStatus]="store().status()"
                               (valueRatingOpened)="openValueRatingModal()"
                               (howToRedeemOpened)="openHowToRedeemModal(campaign)"
                               (viewLocationsOpened)="openViewLocations(campaign)"
                               (cardExpanded)="loadLocations(campaign.id)"
      >
      </app-action-card-preview>
    </div>
  }

  @if (store().isLoading()) {
    <div class="spinner-container">
      <mat-spinner diameter="20"></mat-spinner>
    </div>
  }
</div>
